import { Pipe, PipeTransform } from '@angular/core';

import { Models } from '@ibexfusion/models';

const iconMap = new Map<string, string>([
  ['RES', 'cutlery'],
  ['WAW', 'hiker'],
  ['GBA', 'gondola-small'],
  ['PBA', 'gondola-big'],
  ['ZUG', 'cable-car'],
  ['SSB', 'cable-car-cog'],
  ['BUS', 'bus'],
  ['FBD', 'concierge'],
  ['WEL', 'sauna'],
  ['SKI', 'slope'],
  ['SWI', 'pool']
]);

@Pipe({
  name: 'OpeningState'
})
export class OpeningStatePipe implements PipeTransform {

  constructor() {
  }

  transform(entry: Models.ContentEntry): Models.OpeningStateEntry[] {
    const openingStateEntries = [];

    if (!entry || !entry.detail || !entry.detail.elements || !entry.detail.elements.length) {
      return null;
    }
    for (const rawElement of entry.detail.elements) {
      const element = new Models.OpeningStateEntry();
      element.populateFromJSON({
        sourceId: entry._id,
        title: rawElement.title,
        icon: iconMap.get(rawElement.rawType) ? iconMap.get(rawElement.rawType) : 'star',
        type: rawElement.newType,
        isOpen: rawElement.isOpen
      });
      openingStateEntries.push(element);
    }

    return openingStateEntries;
  }
}
